import { Route } from 'src/routes/Route'
import { CardPaperType, CardType } from 'src/graphql'

const getCardType = (string: string | undefined) => {
  switch (string) {
    case 'POSTCARD':
      return CardType.POSTCARD
    case 'FLATCARD':
      return CardType.FLATCARD
    case 'TWO_PANEL':
      return CardType.TWO_PANEL
    case 'THREE_PANEL':
      return CardType.THREE_PANEL
    case 'TWO_PANEL_BIG':
      return CardType.TWO_PANEL_BIG
    default:
      return undefined
  }
}

const getPaperType = (string: string | undefined) => {
  switch (string) {
    case 'STD':
      return CardPaperType.STD
    case 'PRE':
      return CardPaperType.PRE
    case 'HVY':
      return CardPaperType.HVY
    default:
      return undefined
  }
}

export const SendableCardRoute = Route({
  path: '/preview/:sendableCardId',
  init: (
    sendableCardId: string,
    cardType?: CardType,
    paperType?: CardPaperType,
  ) => ({
    sendableCardId,
    cardType,
    paperType,
  }),
  fromPath: ({ sendableCardId, card_type, paper_type }) =>
    sendableCardId
      ? {
          sendableCardId,
          cardType: getCardType(card_type),
          paperType: getPaperType(paper_type),
        }
      : undefined,
  doNotResetWindowScroll: true,
})
export type SendableCardRoute = Route<typeof SendableCardRoute>
